import { api } from "./client";

export function createSupportTicket(data: {
  type: "bug_report" | "feature_request";
  subject: string;
  description: string;
}) {
  return api.post("/support-tickets", data);
}
